<ng-template vdrDialogTitle>Send Response</ng-template>

<div class="form-grid send-rejection-response" [formGroup]="form">
    <vdr-form-field label="Rejection Response" for="response">
        <textarea id="message" cols="200" rows="10" formControlName="response"></textarea>
    </vdr-form-field>
</div>

<ng-template vdrDialogButtons>
    <button type="button" class="btn" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="send()">Send</button>
</ng-template>
